import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import { BasicVariable } from '../../domain/enrichment/EnrichmentDomain';
import { BasicVariableSchema } from '../../domain/enrichment/EnrichmentSchemaDomains';
import { ComponentDependency } from '../../domain/ui/ComponentMetadata';
import { ChannelActions } from './ChannelActions';

export type BasicActions =
  | 'CHANGE_BASIC'
  | 'CHANGE_BASIC_SCHEMA'
  | 'CHANGE_BASIC_IS_UPDATE'
  | 'CLEAR_BASIC'
  | 'CHANGE_DATA'
  | 'CHANGE_BASIC_DEPENDENCIES'
  | 'CHANGE_BASIC_DIRTY';

export const changeBasic = (payload: BasicVariable | null) =>
  ({
    type: 'CHANGE_BASIC',
    payload,
  }) as ReduxBaseAction<BasicVariable | null, BasicActions>;

export const changeBasicSchema = (payload: BasicVariableSchema | null) =>
  ({
    type: 'CHANGE_BASIC_SCHEMA',
    payload,
  }) as ReduxBaseAction<BasicVariableSchema | null, BasicActions>;

export const changeIsBasicUpdate = (payload: boolean) =>
  ({
    type: 'CHANGE_BASIC_IS_UPDATE',
    payload,
  }) as ReduxBaseAction<boolean, BasicActions>;

export const clearBasic = () =>
  ({
    type: 'CLEAR_BASIC',
  }) as ReduxBaseAction<any, BasicActions>;

export const changeBasicDependencies = (payload: ComponentDependency[]) =>
  ({
    type: 'CHANGE_BASIC_DEPENDENCIES',
    payload,
  }) as ReduxBaseAction<ComponentDependency[], BasicActions>;

export const changeBasicVariableDirty = (payload: boolean) =>
  ({
    type: 'CHANGE_BASIC_DIRTY',
    payload,
  }) as ReduxBaseAction<any, BasicActions>;
